<template>
  <main class="main">
    <main-header />
    <div class="wrapper">
      <sidebar />
      <router-view />
    </div>
  </main>
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";
import MainHeader from "@/components/MainHeader.vue";
export default {
  components: {
    MainHeader,
    Sidebar
  }
};
</script>

<style lang="scss">
@import "@/assets/main.scss";
</style>